import * as React from "react";
import { isPermitted } from "util/PermissionsMixin";
import watchlistFields from "security-content/mappings/watchlistFields";
const fieldIsOnWatchlist = (watchlistStatus, wlFieldType, field) => {
  var _a;
  return !!((_a = watchlistStatus == null ? void 0 : watchlistStatus[wlFieldType]) == null ? void 0 : _a.some((match) => match.fieldName === field));
};
const findWatchlistMatch = (watchlistStatus, wlFieldType, field) => {
  var _a;
  return (_a = watchlistStatus == null ? void 0 : watchlistStatus[wlFieldType]) == null ? void 0 : _a.find((match) => match.fieldName === field);
};
const WatchlistAddition = {
  handler: (lookupTableKey, addToWatchlist) => ({ value }) => addToWatchlist({ watchlistFieldType: lookupTableKey, value }),
  isHidden: (watchlistFieldType, field, currentUserPermissions, watchlistStatus) => !isPermitted(currentUserPermissions, "watchlist:edit") || !watchlistFields[watchlistFieldType].includes(field) || fieldIsOnWatchlist(watchlistStatus, watchlistFieldType, field)
};
const WatchlistRemoval = {
  handler: (lookupTableKey, removeFromWatchlist, watchlistTitle) => ({ value, field, contexts }) => {
    var _a;
    const match = findWatchlistMatch((_a = contexts == null ? void 0 : contexts.watchlistStatus) == null ? void 0 : _a.status, lookupTableKey, field);
    if (match == null ? void 0 : match.matchedViaRange) {
      const confirmMessage = `This value matches range ${match.matchedEntry}. Do you want to remove the entire range from '${watchlistTitle}'?`;
      if (!window.confirm(confirmMessage)) {
        return Promise.resolve();
      }
      return removeFromWatchlist({ watchlistFieldType: lookupTableKey, value: match.matchedEntry });
    }
    return removeFromWatchlist({ watchlistFieldType: lookupTableKey, value });
  },
  isHidden: (watchlistFieldType, field, currentUserPermissions, watchlistStatus) => !isPermitted(currentUserPermissions, "watchlist:delete") || !watchlistFields[watchlistFieldType].includes(field) || !fieldIsOnWatchlist(watchlistStatus, watchlistFieldType, field)
};
const WatchlistActionHelp = (isEnabled) => {
  if (!isEnabled) {
    return {
      title: "Action not possible",
      description: /* @__PURE__ */ React.createElement(React.Fragment, null, "This field value is an array. Removing multiple values from a watchlist is currently not supported. If you want to add or remove included values you can manually edit the watchlist.")
    };
  }
  return void 0;
};
export { WatchlistAddition, WatchlistRemoval, WatchlistActionHelp };
